import { render, staticRenderFns } from "./TokenOTPCertn.vue?vue&type=template&id=b07d675e&scoped=true"
import script from "./TokenOTPCertn.vue?vue&type=script&lang=js"
export * from "./TokenOTPCertn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07d675e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b07d675e')) {
      api.createRecord('b07d675e', component.options)
    } else {
      api.reload('b07d675e', component.options)
    }
    module.hot.accept("./TokenOTPCertn.vue?vue&type=template&id=b07d675e&scoped=true", function () {
      api.rerender('b07d675e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/auth/TokenOTPCertn.vue"
export default component.exports